import React from 'react'
import { Avatar, Typography, Button } from "@material-ui/core";
import moment from "moment";
import DeleteIcon from '@material-ui/icons/Delete';
import { Link, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { delComment } from "./../../../redux/actions/post";

const Comment = ({ comment, post }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const user = JSON.parse(localStorage.getItem("profile"));

    return (
        <>
            <div style={{ display: "flex" }}>
                <Avatar style={{ width: "40px" }} component={Link} to={`/${comment.creator}`}>
                    {comment.name.charAt(0)}
                </Avatar>

                &nbsp;&nbsp;

                <div>
                    <Typography variant="h6" style={{ marginBottom: "-7px" }}>
                        <span style={{ cursor: "pointer" }} onClick={() => history.push(`/${comment.creator}`)}>
                            {comment.name}
                        </span>
                        &nbsp;

                        {user?.user?._id === comment.creator && (
                            <Button color="secondary" size="small"
                                onClick={() => dispatch(delComment(post._id, comment._id))}>
                                <DeleteIcon fontSize="small" />
                            </Button>
                        )}
                    </Typography>

                    <Typography style={{ fontSize: "13px" }} color="textSecondary">
                        {moment(comment.createdAt).fromNow()}
                    </Typography>
                </div>

            </div>

            <div style={{ marginTop: "5px", marginLeft: "50px" }}>

                <Typography component="p" variant="body1">
                    {comment.message}
                </Typography>

            </div>
        </>
    );
}

export default Comment;